import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Form, FormGroup } from '@angular/forms';

// MODELOS
import {
  ManualSendBpInfo, ManualSendCompanyInfo, ManualSendSupplierInfo
} from './../models/index'
import { environment } from 'src/environments/environment';
import { ManualSendReportBPResponse, ManualSendReportCompanyResponse } from '../models/responses';


// RUTAS
// COMPONENTES
// SERVICIOS
import {StorageService} from './storage.service'

@Injectable({
  providedIn: 'root'
})
export class ManualSendService {

  constructor(private http: HttpClient,
    private storageService: StorageService) { }

  // reenvio reporte bp por correo modo manual
  sendManualReportBP(searchBusinessPartnerForm: FormGroup, BusinessPartnerFieldForm: FormGroup) {
    const TOKEN = this.storageService.getToken(); 
    console.log("sendManualReportBP");
    const CardCode = BusinessPartnerFieldForm.controls['CardCode'].value
    let ModCardCode = CardCode.split(' ');
    let currentUser = JSON.parse(this.storageService.getStorage('currentUser'));    
    const ManualSendBpInfo: ManualSendBpInfo = {      
      CompanyId: searchBusinessPartnerForm.controls['companyId'].value,
      CardCode: ModCardCode[0],
      User: currentUser
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<ManualSendReportBPResponse>(`${environment.apiUrl}/api/Documents/SendManualBPReport`,
    ManualSendBpInfo,
      { headers }
    );
  }

  // reenvio reporte compania por correo modo manual
  sendManualCompanyReport(searchBusinessPartnerForm: FormGroup) {
    const TOKEN = this.storageService.getToken();  
    console.log("sendManualCompanyReport");
    let currentUser = JSON.parse(this.storageService.getStorage('currentUser'));
    const ManualSendCompanyInfo: ManualSendCompanyInfo = {      
      CompanyId: searchBusinessPartnerForm.controls['companyId'].value,
      User: currentUser
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<ManualSendReportCompanyResponse>(`${environment.apiUrl}/api/Documents/SendManualCompanyReport`,
    ManualSendCompanyInfo,
      { headers }
    );
  }

  //#region PROVEEDOR
  // reenvio reporte bp por correo modo manual
  sendManualReportSupplier(searchSupplierForm: FormGroup, BusinessPartnerFieldFormSenderReport: FormGroup) {
    const TOKEN = this.storageService.getToken(); 
    console.log("sendManualReportSupplier");
    const CardCode = BusinessPartnerFieldFormSenderReport.controls['CardCodeSenderReport'].value
    let ModCardCode = CardCode.split(' ');
    let currentUser = JSON.parse(this.storageService.getStorage('currentUser'));    
    const ManualSendBpInfo: ManualSendSupplierInfo = {      
      CompanyId: searchSupplierForm.controls['companyId'].value,
      CardCode: ModCardCode[0],
      User: currentUser,
      SendType: searchSupplierForm.controls['sendType'].value,
      StartDate: searchSupplierForm.controls['startDate'].value,
      EndDate: searchSupplierForm.controls['endDate'].value,
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<ManualSendReportBPResponse>(`${environment.apiUrl}/api/Documents/SendManualSupplierReport`,
    ManualSendBpInfo,
      { headers }
    );
  }
  //#endregion PROVEEDOR
}
